export const useAuthStore = defineStore('auth', () => {
  const nuxtApp = useNuxtApp()
  const { user } = useUserSession()

  // Estado reactivo del token
  const byhoursToken = ref<string>(useCookie('byhours_connect').value || '')

  // Función para obtener un token válido (basada en tu getValidByhoursConnect)
  const getValidToken = async (): Promise<string> => {
    const byhoursConnect = useCookie('byhours_connect')
    try {
      // Validar el token actual
      await $fetch(`${useBaseUrl()}/user-data`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'User-token': byhoursToken.value || ''
        },
        query: {
          locale: String(nuxtApp.$i18n.locale.value)
        }
      })

      return byhoursToken.value
    } catch (e) {
      // Si falla, refrescar el token
      try {
        const userEmail = String((user.value as OAuthUser)?.email || '')
        const userPassword = String((user.value as OAuthUser)?.password || '')

        const refreshResponse = await $fetch('/api-web/refresh-token', {
          method: 'POST',
          body: {
            user: {
              email: userEmail,
              password: userPassword
            }
          }
        })

        if (refreshResponse.success && refreshResponse.userToken) {
          byhoursToken.value = refreshResponse.userToken
          byhoursConnect.value = refreshResponse.userToken
          return refreshResponse.userToken
        }
      } catch (refreshError) {
        console.error('Error al refrescar el token:', refreshError)
        byhoursToken.value = ''
        byhoursConnect.value = null
        return ''
      }
    }

    return byhoursToken.value
  }

  // Función para obtener headers con el token
  const getAuthHeaders = async () => {
    const token = await getValidToken()
    return {
      'Content-Type': 'application/json',
      ...(token ? { 'User-token': token } : {})
    }
  }

  return {
    byhoursToken: readonly(byhoursToken),
    getValidToken,
    getAuthHeaders
  }
}) 